<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  tools: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select']);
const isOpen = ref(false);

const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
};

const selectTool = tool => {
  emit('select', tool);
  isOpen.value = false;
};
</script>

<template>
  <div class="relative">
    <Button
      sm
      faded
      slate
      icon="i-lucide-wrench"
      :disabled="disabled"
      @click="toggleDropdown"
    />
    <div
      v-if="isOpen && tools.length"
      class="absolute top-full mt-1 right-0 z-50 min-w-48 bg-n-solid-1 border border-n-container rounded-lg shadow-lg"
    >
      <div class="p-1">
        <button
          v-for="tool in tools"
          :key="tool.id"
          class="w-full px-3 py-2 text-left text-sm text-n-slate-12 hover:bg-n-alpha-2 rounded"
          @click="selectTool(tool)"
        >
          {{ tool.name }}
        </button>
      </div>
    </div>
  </div>
</template>
